import NavigationTabs from 'components/Navigation/NavigationTabs';
import {TeamMemberPermissions} from 'components/Navigation/NavigationTabs/Team/Member';
import SectionHeader from 'components/SectionHeader';
import {useBackend} from 'state/backend';
import {Backend} from 'types/api';

import MemberTable from './MemberTable';
import {Employee, User} from './types';
import UserTable from './UserTable';

export type EmployeeMIDBackendData = Backend<{
    employee: Employee;
    navigationTabs: TeamMemberPermissions;
    user: User;
}>;

const EmployeeMID = () => {
    const {
        data: {employee, navigationTabs, user},
    } = useBackend<EmployeeMIDBackendData>();

    const {isThisUser, mid, name} = employee;

    return (
        <>
            <SectionHeader title={name} />
            <NavigationTabs.TeamMember
                className="my-4"
                mid={mid}
                selection="notifications"
                {...navigationTabs}
            />
            {isThisUser && <UserTable user={user} />}
            <MemberTable employee={employee} user={user} />
        </>
    );
};

export default EmployeeMID;
